module.exports = __webpack_public_path__ + "img/star-user.e175dc83.svg";